import { render, staticRenderFns } from "./PracticalResearchCheckScore.vue?vue&type=template&id=c41a7534"
import script from "./PracticalResearchCheckScore.vue?vue&type=script&lang=js"
export * from "./PracticalResearchCheckScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports